interface StatusIndicatorProps {
  title?: string;
  status?: "done" | "error" | "invalid" | "degraded" | "skip" | "processing" | "pending" | "pages-done" | "segmented";
  className?: string;
  error?: string;
}

export default function StatusIndicator({
  status,
  title,
  className = "",
  error,
}: StatusIndicatorProps) {
  const str = `${title}: ${status}`;

  if (status === "processing" || status === "pages-done") {
    return (
      <div
        title={str}
        className={`w-2 h-2 rounded-full bg-yellow-500 dark:bg-yellow-400 ${className}`}
      />
    );
  }

  if (status === "done" || status === "degraded") {
    return (
      <div
        title={status === "degraded" && error ? `${str}: ${error}` : str}
        className={`w-2 h-2 rounded-full bg-green-500 dark:bg-green-400 ${className}`}
      />
    );
  }

  // Terminal: the page was forked into child segment-pages and does not continue
  // downstream itself. Distinct violet so it reads neither as done nor error.
  if (status === "segmented") {
    return (
      <div
        title={`${title}: segmented`}
        className={`w-2 h-2 rounded-full bg-violet-500 dark:bg-violet-400 ${className}`}
      />
    );
  }

  if (status === "error") {
    return (
      <div
        title={`${str}: ${error ?? "Unknown error"}`}
        className={`w-2 h-2 rounded-full bg-red-500 dark:bg-red-400 ${className}`}
      />
    );
  }

  if (status === "invalid") {
    return (
      <div
        title={`${str}: ${error ?? "File could not be processed — re-upload required"}`}
        className={`w-2 h-2 rounded-full bg-amber-500 dark:bg-amber-400 ${className}`}
      />
    );
  }

  return (
    <div
      title={`${title}: pending`}
      className={`w-2 h-2 rounded-full bg-gray-300 dark:bg-zinc-700 ${className}`}
    />
  );
}
